angular.
module("dx.webapp.exam").
constant("DX_DURATION_SETTING", Object.freeze({
	OFF: 0,
	ON: 1,
	ON_ADJUSTABLE: 2,
}));
